import { TFunction } from 'i18next';
import { IOption } from '../../../types/IOption';
import { Assignment } from './PageToPageAssignmentCard';

const TEMPLATED_IDS = {
  ROLE: '_ROLE_ID_',
  PAGE: '_PAGE_ID_',
};

const replaceRoleId = (url: string, roleId: string) => url.replace(TEMPLATED_IDS.ROLE, roleId);
const replacePageId = (url: string, pageId: string) => url.replace(TEMPLATED_IDS.PAGE, pageId);

/**
 * Templated URl provided by the backend, used to retrieve all data for a single assignment.
 * - create form: need to replace roleId & pageId, as page id can be selected.
 * - edit form: only roleId need to be replaced.
 */
export const templateUrl = ({ url, roleId, pageId }: { url: string; roleId?: string; pageId?: string }) => {
  const replacedRoleString = roleId ? replaceRoleId(url, roleId) : url;
  return pageId ? replacePageId(replacedRoleString, pageId) : replacedRoleString;
};

export function normalizeOption(options: PageToPageRoleFormOption[] | undefined, t: TFunction) {
  return options?.map((option) => {
    const direction = option.bidirectional ? t('bidirectional') : t('unidirectional');
    return { value: option.value, text: `${option.text} (${direction})` };
  });
}

export function normalizePageToPageOption(
  options: PageToPageRoleFormOption[] | undefined,
  allAllowedRoles: string[] | undefined,
  t: TFunction,
) {
  const filteredOptions = options?.filter(
    option => allAllowedRoles?.includes(option.value.substring(1)), // Remove leading '<' or '>'.
  );
  return normalizeOption(filteredOptions, t);
}

export function updateAssignmentWithNewRole(
  assignment: Assignment,
  options: IOption[] | undefined,
  id: string,
): Assignment {
  const text = options?.find(option => option.value === id)?.text;

  return {
    ...assignment,
    role: text,
  } as Assignment;
}

export type GetAllAllowedRolesResponse = string[];

export type PageToPageRoleFormOption = {
  value: string;
  bidirectional: boolean;
  text: string;
};
